import React, { useMemo, useCallback } from "react";
import { Modal, Table } from "antd";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { useSelector } from "react-redux";
import { getCountryTimezone } from "redux/selectors";
import moment from "moment";

const StyledModal = styled(Modal)`
  width: 600px !important;
  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;

const StyleLocation = styled.div`
  a {
    font-size: 12px;
  }
`;

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    max-height: 500px;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 10px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
`;

const rowClassName = (record, index) => (index % 2 === 0 ? "" : "non-white");

function LocationBasedAttendanceList({
  displayModal,
  toggleModal,
  title,
  list,
  reportType,
  userInfo,
  userList,
}) {
  const CountryTimezone = useSelector(getCountryTimezone);

  const timezone = useMemo(() => {
    const finduser = userList?.find((item) => item?.userid === userInfo?.userid);
    const managingOffice = Array.isArray(finduser?.managingoffice)
      ? finduser?.managingoffice[0]
      : finduser?.managingoffice;
    const found = CountryTimezone?.find((item) => item?.country === managingOffice);
    return found?.Timezone ?? "UTC";
  }, [userList, userInfo?.userid, CountryTimezone]);

  const columns = useMemo(() => {
    const base = [
      {
        title: "Name",
        dataIndex: "fullname",
        key: "fullname",
      },
      {
        title: "Check-In Time",
        dataIndex: "checkintime",
        key: "checkintime",
        align: "center",
        render: (text) =>
          moment.utc(text, "HH:mm:ss").tz(timezone)?.format("hh:mm A"),
      },
    ];

    if (reportType === "Others" || reportType === "Other") {
      base.push({
        title: <div>Location</div>,
        dataIndex: "location",
        key: "loginLatitude",
        className: "normal-column",
        align: "center",
        render: (_, record) => {
          const url1 = `http://maps.google.com/maps/?q=${record.loginLatitude},${record.loginLongitude}`;
          return record.loginLatitude !== "" && record.loginLongitude !== "" ? (
            <StyleLocation className="location">
              <a href={url1} target="_blank" rel="noreferrer">
                {record.loginLatitude}, {record.loginLongitude}
              </a>
            </StyleLocation>
          ) : (
            "-"
          );
        },
      });
    }

    return base;
  }, [timezone, reportType]);

  return (
    <StyledModal
      title={title}
      visible={displayModal}
      onCancel={toggleModal}
      footer={null}
      destroyOnClose
    >
      <StyledTable
        dataSource={list}
        columns={columns}
        rowClassName={rowClassName}
        rowKey="name"
        pagination={false}
      />
    </StyledModal>
  );
}

export default React.memo(LocationBasedAttendanceList);